import { useState } from 'react'
import axios from 'axios'

export type HookResponse = {
    data?: {
      [key: string]: string[]
    }
    lastModified?: string
  }

export type StandingsRespone = {
    data?: {[key: string]: string[][]}[]
    lastModified?: string
}

export const useEsportsAPI = () => {
    const [loading, setLoading] = useState(false)

    const getSchedule= async () => {
        try {
            setLoading(true)
            const cachedResponse = localStorage.getItem("schedule")
            if (cachedResponse) {
                const cachedResponseJSON = JSON.parse(cachedResponse)
                const remoteLastModifiedDate = (await axios.get("https://akysb-esports-api.herokuapp.com/modifiedDate")).data["modifiedTime"]
                if (cachedResponseJSON.data["lastModifiedDate"] >= remoteLastModifiedDate) {
                    return cachedResponseJSON
                }
            }
            const response = await axios.get("https://akysb-esports-api.herokuapp.com/schedule")
            localStorage.setItem("schedule", JSON.stringify(response))
            return response
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const getStandings= async () => {
        try {
            setLoading(true)
            const cachedResponse = localStorage.getItem("standings")
            if (cachedResponse) {
                const cachedResponseJSON = JSON.parse(cachedResponse)
                const remoteLastModifiedDate = (await axios.get("https://akysb-esports-api.herokuapp.com/modifiedDate")).data["modifiedTime"]
                if (cachedResponseJSON.data["lastModifiedDate"] >= remoteLastModifiedDate) {
                    return cachedResponseJSON
                }
            }
            const response = await axios.get("https://akysb-esports-api.herokuapp.com/standings")
            localStorage.setItem("standings", JSON.stringify(response))
            return response
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    const getPlayoffs = async () => {
        try {
            setLoading(true)
            const cachedResponse = localStorage.getItem("playoffs")
            if (cachedResponse) {
                const cachedResponseJSON = JSON.parse(cachedResponse)
                const remoteLastModifiedDate = (await axios.get("https://akysb-esports-api.herokuapp.com/modifiedDate")).data["modifiedTime"]
                if (cachedResponseJSON.data["lastModifiedDate"] >= remoteLastModifiedDate) {
                    return cachedResponseJSON
                }
            }
            const response = await axios.get("https://akysb-esports-api.herokuapp.com/playoffs")
            localStorage.setItem("playoffs", JSON.stringify(response))
            return response
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    return {
        getSchedule,
        getStandings,
        getPlayoffs,
        loading,
    }
}